import { styled } from '@mui/material/styles';

import { device } from 'src/constants/muiSize';

export const Button = styled('button')(({ theme }) => ({
  width: '100%',
  height: '100%',

  display: 'flex',
  alignItems: 'center',

  backgroundColor: 'transparent',
  padding: '1rem 3rem',
  border: 'none',

  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.colors.base06,
    '* > img': {
      transform: 'scale(1.06)',
      transition: 'transform 0.3s ease-in-out',
    },
  },
}));

export const ImageContainer = styled('div')(({ theme }) => ({
  borderRadius: '1rem',
  border: `0.1rem solid ${theme.colors.base05}`,

  overflow: 'hidden',

  position: 'relative',

  '& > img': {
    width: '17rem',
    height: 'auto',
    display: 'block',
  },
}));

export const ContentsContainer = styled('div')({
  height: '100%',

  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',

  rowGap: '1.6rem',

  padding: '1.2rem 0 1.2rem 2rem',

  [`@media ${device.macLaptop}`]: {
    display: 'none',
  },
});

export const TitleContainer = styled('div')(({ theme }) => ({
  width: '21rem',

  color: theme.colors.base01,

  textAlign: 'left',

  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',

  display: '-webkit-box',

  wordWrap: 'break-word',

  overflow: 'hidden',
}));

export const FooterContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const TagBadge = styled('div')(({ theme }) => ({
  borderRadius: '0.4rem',

  border: `0.06rem solid rgba(105, 165, 255, 0.60)`,

  backgroundColor: `rgba(105, 165, 255, 0.10)`,

  padding: '0.3rem 0.6rem',

  color: theme.colors.accentBlue,
}));

export const Base02TextContainer = styled('div')(({ theme }) => ({
  color: theme.colors.base02,
}));

export const FlagImageContainer = styled('div')({
  position: 'absolute',
  top: '0',
  right: '0',
});

export const PlayTimeContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  columnGap: '0.2rem',

  position: 'absolute',
  bottom: '0.8rem',
  left: '0.8rem',

  color: theme.colors.base01,
}));
